import React from 'react';
import {
    Wrapper,
    Answer,
    Image,
    Question,
    Container
} from './Poll.styles';
import { PollProps } from './Poll.interface';

export function Poll({ image, dataCreate, dataDetails }: PollProps) {
    return (
        <Wrapper>
            <Image src={image} alt="Poll image" />
            <Container>
                <Question>{dataCreate?.question || dataDetails?.pollQuestion}</Question>
                {dataCreate?.choices.map((answer: string) => (
                    <Answer key={answer}>{answer}</Answer>
                ))}
                {dataDetails?.answers?.map((answer: {id: number; questionAnswer: string}) => (
                    <Answer key={answer.id}>{answer.questionAnswer}</Answer>
                ))}
            </Container>
        </Wrapper>
    )
}
